<template>
  <div class="notification-container">
    <h1 class="mt-0 mb-2 text-lg text-center">
      Edyst Campaigns and Notifications
    </h1>
    <div class="flex h-full" style="height: calc(100vh - 3.25rem);">
      <aside class="sidebar flex flex-col mr-4">
        <h3 class="text-center my-4 border-b pb-2">Tabs</h3>
        <button
          class="tab-btn"
          :class="{ 'tab-active': activeTab === 'templates' }"
          @click="setTab('templates')"
        >
          Templates
        </button>
        <button
          class="tab-btn"
          :class="{ 'tab-active': activeTab === 'segments' }"
          @click="setTab('segments')"
        >
          Segments
        </button>
        <div class="border-t mt-2 pt-2">
          <button
            class="tab-btn"
            :class="{ 'tab-active': activeTab === 'announcements' }"
            @click="setTab('announcements')"
          >
            Announcements
          </button>
        </div>
        <div class="border-t mt-2 pt-2">
          <button
            class="tab-btn"
            :class="{ 'tab-active': activeTab === 'rules' }"
            @click="setTab('rules')"
          >
            Configure Rules
          </button>
        </div>
      </aside>
      <div class="main w-full h-full">
        <Segment v-if="activeTab === 'segments'" class="w-full h-full" />
        <Template v-if="activeTab === 'templates'" class="w-full h-full" />
        <Announcement
          v-if="activeTab === 'announcements'"
          class="w-full h-full"
        />
        <Rules v-if="activeTab === 'rules'" class="w-full h-full" />
      </div>
    </div>
  </div>
</template>

<script>
import Template from "@/components/Notification/Template"
import Segment from "@/components/Notification/Segment"
import Announcement from "@/components/Notification/Announcement"
import Rules from "@/components/Notification/Rules"

export default {
  components: {
    Segment,
    Template,
    Announcement,
    Rules,
  },
  computed: {
    activeTab() {
      if (this.$route.query && this.$route.query.tab) {
        return this.$route.query.tab
      }
      return "templates"
    },
  },
  created() {
    if (!this.$route.query || !this.$route.query.tab) {
      const routeObj = { ...this.$route, query: { ...this.$route.query } }
      routeObj.query.tab = "templates"
      this.$router.replace(routeObj).catch(() => {})
    }
  },
  methods: {
    setTab(tab) {
      this.updateRoute({ key: "tab", value: tab })
    },
    updateRoute(data) {
      const routeObj = { ...this.$route, query: { ...this.$route.query } }
      routeObj.query[data.key] = data.value
      this.$router.push(routeObj).catch(() => {})
    },
  },
}
</script>

<style scoped lang="scss">
.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.2rem;
}

.close-button:hover {
  border-radius: 3px;
  background: #ffffff;
}

.sidebar {
  position: fixed;
  top: 3.5rem;
  width: 15rem;
  height: 100%;
  padding-right: 1rem;
  border-right: 1px solid #d3d3d3;
}

.main {
  margin-left: 16rem;
}

.tab-btn {
  width: 100%;
  margin-bottom: 0.5rem;
  padding: 1rem;
  border-radius: 3px;
  background: transparent;
  font-weight: normal;
}

.tab-btn:hover,
.tab-btn:active,
.tab-btn:focus {
  color: #58b4ff;
  background: #ffffff;
}

.tab-active {
  color: #58b4ff;
  background: #ffffff;
  font-weight: bold;

  @apply shadow-md;
}
</style>
